/**
 * EmptyTrendNotice.tsx — sparse-data placeholder for trend / line charts.
 *
 * Phase 2 ships against a DB that frequently has only ONE snapshot, so
 * line charts would render as a single point. PHASE2_SPEC §3 mandates we
 * hide the chart when `trend.length < 2` and show this notice instead.
 */

import React from 'react';

import { formatDate } from '../helpers/dateFormat';

interface Props {
	asOf?: string | null;
	/** Override the default verbiage if a page wants to be more specific. */
	hint?: string;
}

export default function EmptyTrendNotice({ asOf, hint }: Props) {
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: 36,
				color: 'var(--text-dim)',
				fontSize: 13,
				textAlign: 'center',
				background: 'var(--ink-50)',
				borderRadius: 'var(--radius-sm)',
				border: '1px dashed var(--border)',
			}}
			role="status"
		>
			<div>
				<div style={{ fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>
					Trend not available yet
				</div>
				<div>
					{hint ??
						'Trend will appear once more daily snapshots are loaded.'}
					{asOf && <> As of {formatDate(asOf)}.</>}
				</div>
			</div>
		</div>
	);
}
